import Stack from "@/tpo/Stack";

import ExploreTestsSection from "./ExploreTestsSection";
import LatestWebinarsSection from "./LatestWebinarsSection";
import LunchAndLearnsSection from "./LunchAndLearnsSection";
import NewestCpdCoursesSection from "./NewestCpdCoursesSection";
import UpcomingEventsSection from "./UpcomingEventsSection";
import { dashboardMainStackMaxWidth, learningHubDashboardMainStackGap } from "./dashboardLayout";

export default function DashboardSections() {
  return (
    <Stack
      gap={learningHubDashboardMainStackGap}
      flex="1 1 0%"
      minWidth={0}
      maxWidth={dashboardMainStackMaxWidth}
      width="100%"
    >
      <UpcomingEventsSection />
      <LatestWebinarsSection />
      <NewestCpdCoursesSection />
      <LunchAndLearnsSection />
      <ExploreTestsSection />
    </Stack>
  );
}
